import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'badgeClass' })
export class BadgeClassPipe implements PipeTransform {
  transform(units: number, average: number): string {
    if (average === null || average === 0) return 'bg-success';
    const diff = units - average;
    const percent = diff / average;
    if (percent >= 0) return 'bg-success'; // verde si igual o mayor al average
    if (percent < 0 && percent >= -0.20) return 'bg-success'; // verde hasta 20% por debajo
    if (percent < -0.20 && percent >= -0.40) return 'bg-warning'; // amarillo 21-40% por debajo
    return 'bg-danger'; // rojo más de 40% por debajo
  }
}